import type { IconData } from '@stacksjs/iconify-core'

export const sadFace: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3s21 9.402 21 21Z\"/><path stroke-linecap=\"round\" d=\"M15 17v2m18-2v2m-1 16a8 8 0 1 0-16 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sadFace
